export default "__VITE_ASSET__e8484976__"